import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AppShell from "./layout/AppShell";
import Dashboard from "./pages/Dashboard";
import Brands from "./pages/Brands";
import Outlets from "./pages/Outlets";
import Assets from "./pages/Assets";
import Manufacturers from "./pages/Manufacturers";
import Subscriptions from "./pages/Subscriptions";
import Maintenance from "./pages/Maintenance";
import Warranty from "./pages/Warranty";
import Users from "./pages/Users";
import Reports from "./pages/Reports";
import Notifications from "./pages/Notifications";
import AuditLogs from "./pages/AuditLogs";
import Settings from "./pages/Settings";
import ControlTower from "./pages/ControlTower";
import CapitalPartners from "./pages/CapitalPartners";
import AssetPools from "./pages/AssetPools";
import Recovery from "./pages/Recovery";
import Approvals from "./pages/Approvals";
import Documents from "./pages/Documents";
import AssetDetail from "./pages/AssetDetail";
import IoTDevices from "./pages/IoTDevices";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RefundPolicy from "./pages/RefundPolicy";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return <div className="h-screen w-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/terms-and-conditions" element={<TermsConditions />} />
<Route path="/refund-policy" element={<RefundPolicy />} />
      <Route element={<Protected><AppShell /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/outlets" element={<Outlets />} />
        <Route path="/assets" element={<Assets />} />
        <Route path="/assets/:id" element={<AssetDetail />} />
        <Route path="/manufacturers" element={<Manufacturers />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/warranty" element={<Warranty />} />
        <Route path="/users" element={<Users />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/audit-logs" element={<AuditLogs />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/control-tower" element={<ControlTower />} />
        <Route path="/capital-partners" element={<CapitalPartners />} />
        <Route path="/asset-pools" element={<AssetPools />} />
        <Route path="/recovery" element={<Recovery />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/iot-devices" element={<IoTDevices />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
